import { BaseRequestResultModel, ResultModel } from '../models/base-request-result.model';

export abstract class BaseService {
	protected extractData(response: BaseRequestResultModel): ResultModel {
		if (!response.data || response.data.length === 0) console.log('Falha ao buscar!');

		return response.data[0];
	}
}
